import { Card, CardContent, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { memo } from 'react';

interface KPICardProps {
	title: string;
	value: string | number;
	subtitle?: string;
	color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error';
}

export const KPICard: React.FC<KPICardProps> = memo(({ title, value, subtitle, color = 'primary' }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Card sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
			<CardContent sx={{ flex: 1, p: { xs: 1.5, sm: 2 }, '&:last-child': { pb: { xs: 1.5, sm: 2 } } }}>
				<Typography
					color="text.secondary"
					gutterBottom
					variant="body2"
					sx={{
						fontSize: { xs: '0.75rem', sm: '0.875rem' },
						wordBreak: 'break-word',
						overflowWrap: 'anywhere'
					}}
				>
					{title}
				</Typography>
				<Typography
					variant={isMobile ? 'h5' : 'h4'}
					component="div"
					color={`${color}.main`}
					fontWeight="bold"
					sx={{ fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' } }}
				>
					{typeof value === 'number' ? value.toLocaleString('vi-VN') : value}
				</Typography>
				{subtitle && (
					<Typography
						variant="body2"
						color="text.secondary"
						sx={{
							fontSize: { xs: '0.7rem', sm: '0.875rem' },
							wordBreak: 'break-word',
							overflowWrap: 'anywhere'
						}}
					>
						{subtitle}
					</Typography>
				)}
			</CardContent>
		</Card>
	);
});

KPICard.displayName = 'KPICard';
